import { FC } from 'react';

import { ItemsContainer, RetailsWrapper } from '../Retails.styles';
import { FilterSkeleton, MapSkeleton } from './RetailsSkeleton.styles';

export const RetailsSkeleton: FC = () => {
    return (
        <RetailsWrapper>
            <ItemsContainer $gridArea="map">
                <MapSkeleton />
            </ItemsContainer>
            <ItemsContainer $gridArea="above">
                <FilterSkeleton />
                <FilterSkeleton />
                <FilterSkeleton />
            </ItemsContainer>
        </RetailsWrapper>
    );
};
